import script from "./container-wrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./container-wrapper.vue?vue&type=script&setup=true&lang=js"

import "./container-wrapper.vue?vue&type=style&index=0&id=4864a100&lang=css"

const __exports__ = script;

export default __exports__